import type { ReactElement } from 'react';
import {
  Button,
  Dialog,
  DialogActions,
  DialogBody,
  DialogContent,
  DialogSurface,
  DialogTitle,
  Text,
} from '@fluentui/react-components';
import { brandName } from '@gandhi/mail-protocol';
import { useController, useMail } from '../state/context.js';

/**
 * The one place a conversation is allowed to change brand. Both brands are named in
 * the title, in the body and on the confirming button, so the answer cannot be given
 * without reading which brand is being swapped for which.
 */
export function BrandChangeDialog(): ReactElement | null {
  const controller = useController();
  const brandChange = useMail((s) => s.brandChange);
  if (brandChange === null) return null;

  const from = brandName(brandChange.fromBrand);
  const to = brandName(brandChange.toBrand);

  return (
    <Dialog open modalType="alert">
      <DialogSurface data-testid="brand-change-dialog">
        <DialogBody>
          <DialogTitle>
            Change brand from {from} to {to}?
          </DialogTitle>
          <DialogContent>
            <Text>{brandChange.message}</Text>
          </DialogContent>
          <DialogActions>
            <Button appearance="secondary" onClick={() => controller.cancelBrandChange()}>
              Keep {from}
            </Button>
            <Button
              appearance="primary"
              data-testid="confirm-brand-change"
              onClick={() => void controller.confirmBrandChange()}
            >
              Change to {to}
            </Button>
          </DialogActions>
        </DialogBody>
      </DialogSurface>
    </Dialog>
  );
}
